export const searchIndexes = [
  // MERCHANTS

  // Products
  {
    name: "arktastic products",
    slug: `/merchant/products?mid=6026b181fb8ffa0ac289a7c1&status=all`,
    merchant: {
      id: "6026b181fb8ffa0ac289a7c1",
      name: "Arktastic",
    },
  },
  {
    name: "aqua & rock products",
    slug: `/merchant/products?mid=60871bb37e7dd6291a34a339&status=all`,
    merchant: {
      id: "60871bb37e7dd6291a34a339",
      name: "Aqua & Rock",
    },
  },
  {
    name: "arktastic candles products",
    slug: `/merchant/products?mid=6167b3e7d02f7e05ca02a15a&status=all`,
    merchant: {
      id: "6167b3e7d02f7e05ca02a15a",
      name: "Arktastic Candles",
    },
  },
  {
    name: "arktastic giftsets products",
    slug: `/merchant/products?mid=61972764cc0d3b2c25e15ad5&status=all`,
    merchant: {
      id: "61972764cc0d3b2c25e15ad5",
      name: "Arktastic Giftsets",
    },
  },
  {
    name: "arktastic watches products",
    slug: `/merchant/products?mid=607c8f816dc3a6cdf33ffed9&status=all`,
    merchant: {
      id: "607c8f816dc3a6cdf33ffed9",
      name: "Arktastic Watches",
    },
  },
  {
    name: "catchy time products",
    slug: `/merchant/products?mid=60c184be5f926c8d29469a2b&status=all`,
    merchant: {
      id: "60c184be5f926c8d29469a2b",
      name: "CATCHY TIME",
    },
  },
  {
    name: "kapraaha products",
    slug: `/merchant/products?mid=60e590e0f192608c5278a083&status=all`,
    merchant: {
      id: "60e590e0f192608c5278a083",
      name: "KAPRAAHA",
    },
  },
  {
    name: "moonlord products",
    slug: `/merchant/products?mid=6144476d3374073719a4fccd&status=all`,
    merchant: {
      id: "6144476d3374073719a4fccd",
      name: "Moonlord",
    },
  },

  //  Orders
  {
    name: "arktastic orders",
    slug: `/admin/orders/Arktastic/6026b181fb8ffa0ac289a7c1?page=1`,
    merchant: {
      id: "6026b181fb8ffa0ac289a7c1",
      name: "Arktastic",
    },
  },
  {
    name: "aqua & rock orders",
    slug: `/admin/orders/Aqua & Rock/60871bb37e7dd6291a34a339?page=1`,
    merchant: {
      id: "60871bb37e7dd6291a34a339",
      name: "Aqua & Rock",
    },
  },
  {
    name: "arktastic candles orders",
    slug: `/admin/orders/Arktastic Candles/6167b3e7d02f7e05ca02a15a?page=1`,
    merchant: {
      id: "6167b3e7d02f7e05ca02a15a",
      name: "Arktastic Candles",
    },
  },
  {
    name: "arktastic giftsets orders",
    slug: `/admin/orders/Arktastic Giftsets/61972764cc0d3b2c25e15ad5?page=1`,
    merchant: {
      id: "61972764cc0d3b2c25e15ad5",
      name: "Arktastic Giftsets",
    },
  },
  {
    name: "arktastic watches orders",
    slug: `/admin/orders/Arktastic Watches/607c8f816dc3a6cdf33ffed9?page=1`,
    merchant: {
      id: "607c8f816dc3a6cdf33ffed9",
      name: "Arktastic Watches",
    },
  },
  {
    name: "catchy time orders",
    slug: `/admin/orders/CATCHY TIME/60c184be5f926c8d29469a2b?page=1`,
    merchant: {
      id: "60c184be5f926c8d29469a2b",
      name: "CATCHY TIME",
    },
  },
  {
    name: "kapraaha orders",
    slug: `/admin/orders/KAPRAAHA/60e590e0f192608c5278a083?page=1`,
    merchant: {
      id: "60e590e0f192608c5278a083",
      name: "KAPRAAHA",
    },
  },
  {
    name: "moonlord orders",
    slug: `/admin/orders/Moonlord/6144476d3374073719a4fccd?page=1`,
    merchant: {
      id: "6144476d3374073719a4fccd",
      name: "Moonlord",
    },
  },

  //  Brands
  {
    name: "arktastic brands",
    slug: `/merchant/listbrands/6026b181fb8ffa0ac289a7c1&status=all`,
    merchant: {
      id: "6026b181fb8ffa0ac289a7c1",
      name: "Arktastic",
    },
  },
  {
    name: "aqua & rock brands",
    slug: `/merchant/listbrands/60871bb37e7dd6291a34a339&status=all`,
    merchant: {
      id: "60871bb37e7dd6291a34a339",
      name: "Aqua & Rock",
    },
  },
  {
    name: "arktastic candles brands",
    slug: `/merchant/listbrands/6167b3e7d02f7e05ca02a15a&status=all`,
    merchant: {
      id: "6167b3e7d02f7e05ca02a15a",
      name: "Arktastic Candles",
    },
  },
  {
    name: "arktastic giftsets brands",
    slug: `/merchant/listbrands/61972764cc0d3b2c25e15ad5&status=all`,
    merchant: {
      id: "61972764cc0d3b2c25e15ad5",
      name: "Arktastic Giftsets",
    },
  },
  {
    name: "arktastic watches brands",
    slug: `/merchant/listbrands/607c8f816dc3a6cdf33ffed9&status=all`,
    merchant: {
      id: "607c8f816dc3a6cdf33ffed9",
      name: "Arktastic Watches",
    },
  },
  {
    name: "catchy time brands",
    slug: `/merchant/listbrands/60c184be5f926c8d29469a2b&status=all`,
    merchant: {
      id: "60c184be5f926c8d29469a2b",
      name: "CATCHY TIME",
    },
  },
  {
    name: "kapraaha brands",
    slug: `/merchant/listbrands/60e590e0f192608c5278a083&status=all`,
    merchant: {
      id: "60e590e0f192608c5278a083",
      name: "KAPRAAHA",
    },
  },
  {
    name: "moonlord brands",
    slug: `/merchant/listbrands/6144476d3374073719a4fccd&status=all`,
    merchant: {
      id: "6144476d3374073719a4fccd",
      name: "Moonlord",
    },
  },

  //   All Lists
  {
    name: "all products",
    slug: `/merchant/products`,
  },
  {
    name: "all orders",
    slug: `/AllOrders/list`,
  },
  {
    name: "all pages",
    slug: `/pages`,
  },
  {
    name: "categories",
    slug: `/category`,
  },
  {
    name: "all brands",
    slug: `/brands`,
  },
  {
    name: "add brand",
    slug: `brands/add`,
  },
  {
    name: "tags",
    slug: `/tags`,
  },
  {
    name: "create tag",
    slug: `/create/tag`,
  },
  {
    name: "all customers",
    slug: `/customerlist`,
  },
  {
    name: "mail schedular",
    slug: `/mails`,
  },
  {
    name: "coupons",
    slug: `/coupon/list`,
  },
  {
    name: "create coupon",
    slug: `/coupon/create`,
  },
  {
    name: "support cases",
    slug: `/support-cases`,
  },
  {
    name: "customer issues",
    slug: `/support-cases`,
  },
  {
    name: "customer support",
    slug: `/support-cases`,
  },
  {
    name: "reviews",
    slug: `/reviews`,
  },
];
